import { useId } from 'react';
import type { AnalyticsEvent } from '../../services/analytics';
import styles from './EventSelect.module.css';

interface EventSelectProps {
    label: string;
    value: string;
    options: AnalyticsEvent[];
    onChange: (id: string) => void;
}

export function EventSelect({ label, value, options, onChange }: EventSelectProps) {
    const id = useId();
    return (
        <div className={styles.field}>
            <label htmlFor={id} className={styles.label}>
                {label}
            </label>
            <select id={id} className={styles.select} value={value} onChange={(e) => onChange(e.target.value)}>
                {options.map((o) => (
                    <option key={o.id} value={o.id}>
                        {o.label}
                    </option>
                ))}
            </select>
        </div>
    );
}
